// OL hands pointer moves over its controls (sidebar, drawer, hover box) to the map too,
// so every `pointerMove` Select would hover features hidden behind them. Over a
// control, hit-tests get a pixel off the map; the coordinate stays the pointer's.
const OFF_MAP_PIXEL = [-100000, -100000];

/** Register before any other pointermove listener: map listeners run in order. */
export function ignoreHoverOverControls(map) {
  const controls = map.getOverlayContainerStopEvent();
  map.on("pointermove", (e) => {
    if (!controls.contains(e.originalEvent.target)) return;
    // Cache the real coordinate first: it is computed lazily from the pixel.
    void e.coordinate;
    e.pixel = OFF_MAP_PIXEL;
  });
}

/**
 * Calls `clear` once each time the pointer moves from the map onto a control, for
 * hover drawings that only redraw while the pointer is over the map.
 */
export function onPointerOntoControls(map, clear) {
  const controls = map.getOverlayContainerStopEvent();
  let onMap = false;
  map.on("pointermove", (e) => {
    if (!controls.contains(e.originalEvent.target)) {
      onMap = true;
      return;
    }
    if (!onMap) return;
    onMap = false;
    clear();
  });
}
